export const getSiteUrl = (): string => {
  // Prefer explicit frontend URL, then fall back to API root (same origin),
  // then window.location for client-side runtime.
  const envFrontend = (process.env.REACT_APP_FRONTEND_URL || '').trim();
  const envApi = (process.env.REACT_APP_API_URL || '').trim();
  const chosen = envFrontend || envApi;
  if (chosen) return chosen.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) return window.location.origin;
  return '';
};
